export default {
    snackbar: {
        show: false,
        timeout: 3000,
        color: 'viortis',
        text: ''
    },
    title: ''
}